// 유니온 등록 신청에 커뮤니티 유형이 필수다(2026-09-15 마이그레이션). 이 선택이 없으면
// 신청이 community_type_required 로 거절된다.
const COMMUNITY_TYPES = [
  ['gallery', '갤러리(갤길)'],
  ['channel', '채널(챈길)'],
];

export function CommunityTypePicker({ value, onChange, disabled = false, idPrefix = 'entry' }) {
  return (
    <fieldset className="entry-community-type" disabled={disabled}>
      <legend>커뮤니티 유형</legend>
      <div>
        {COMMUNITY_TYPES.map(([type, label]) => (
          <label key={type} htmlFor={`${idPrefix}-community-${type}`}>
            <input
              id={`${idPrefix}-community-${type}`}
              type="radio"
              name={`${idPrefix}-community-type`}
              value={type}
              checked={value === type}
              onChange={() => onChange(type)}
            />
            <span>{label}</span>
          </label>
        ))}
      </div>
    </fieldset>
  );
}
